import { StopNotesAndReferenceNumbers } from "../StopNotesAndReferenceNumbers";
import { StopShowAsButton } from "../StopShowAsButton";
import { Button, CityState, DataSource, Image, Label, Layout, Location, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOrderStop extends Layout {
    buttonAddLocation: Button;
    citystate: CityState;
    dfXref: Label;
    imageYSplitPick: Image;
    imageYsplitDrop: Image;
    labelAdditionalStopDetails: Label;
    labelCreatingLocation: Label;
    labelLabelBetween: Label;
    layoutStopNotesAndRefNbrs: StopNotesAndReferenceNumbers;
    layoutStopShowAsButton: StopShowAsButton;
    panel1: Panel;
    panelAdditionalDetails: Panel;
    panelLateArrival: Panel;
    panelMain: Panel;
    panelStopCommentsReferenceNumbers: Panel;
    panelStopFreeForm: Panel;
    panelStopType: Panel;
    sourceAppointmentChange: DataSource;
    sourceStop: DataSource;
    switchApptRequired: Switch;
    switchConfirmed: Switch;
    switchPalletsRequired: Switch;
    textboxAddress2: Textbox;
    textboxAddress: Textbox;
    textboxAppointmentStatusId: Textbox;
    textboxApptStatus: Textbox;
    textboxCases: Textbox;
    textboxContactEmail: Textbox;
    textboxContactName: Textbox;
    textboxDriverLoadUnload: Textbox;
    textboxEdiLocCode: Textbox;
    textboxLocationCode: Textbox;
    textboxLocationId: Location;
    textboxLocationName: Textbox;
    textboxPalletsHowMany: Textbox;
    textboxPhone: Textbox;
    textboxSchedArriveEarly: Textbox;
    textboxSchedArriveLate: Textbox;
    textboxSignedForName: Textbox;
    textboxStopDateType: Textbox;
    textboxStopType: Textbox;
    textboxVolume: Textbox;
    textboxWeight: Textbox;
    textboxZoneId: Textbox;
}
